import { Strategy } from 'utility-ts-strategy';

export const TransactionRequestType = new Strategy({
  ADD: 'Registration',
  DROP: 'Drop',
  SWAP: 'Swap',
  WAITLIST: 'Waitlist',
  WITHDRAW: 'Withdraw'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration_transactions/strategies/request_type_strategy.ts